/**
 * A frase executiva do lead: o que aconteceu, em uma linha, logo abaixo do
 * hero. "Abandonou R$ 897,00 há 3 h · recebeu 2 ligações e 1 WhatsApp ·
 * último contato há 2 h (WhatsApp T+49min) · pagou há 2 h, creditado ao
 * WhatsApp T+49min · comissão R$ 134,55".
 *
 * Os numeros ficam em <strong> para o olho pular de fato em fato; a mesma
 * frase corrida vai no `title` e no leitor de tela. Quando a janela de
 * comissao esta aberta, uma segunda linha diz ate quando -- e o dado que
 * decide se vale a pena um contato humano agora.
 */

import { Icon, Panel } from '../../../components/ui';
import { formatDateTime } from '../../../lib/format';
import type { ResumoExecutivoDoLead } from '../resumo';
import { CANAL, descreverRelativo, SITUACAO } from '../vocabulario';

export function ResumoExecutivo({ resumo, agora }: { readonly resumo: ResumoExecutivoDoLead; readonly agora: Date }): JSX.Element {
  const ultimo = resumo.segmentos.length - 1;
  const janela = resumo.janela;
  return (
    <Panel tone="elevated" className="px-5 py-4">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-subtle">Em uma frase</p>
      <p className="mt-1 text-base leading-relaxed text-ink" title={resumo.frase}>
        {resumo.segmentos.map((s, i) => (
          <span key={s.key}>
            {s.antes}
            <strong className="font-semibold tabular-nums">{s.destaque}</strong>
            {s.depois}
            {i < ultimo ? <span className="text-ink-subtle"> · </span> : '.'}
          </span>
        ))}
      </p>
      {janela !== null && SITUACAO[resumo.situacao].emAberto ? (
        <p className={`mt-2 inline-flex flex-wrap items-center gap-1.5 text-xs ${janela.aberta ? 'text-ink-muted' : 'text-status-warning'}`}>
          <Icon name="escudo" size="xs" />
          {janela.aberta ? (
            <>
              Janela de comissão aberta até <strong className="tabular-nums text-ink">{formatDateTime(janela.terminaEm)}</strong> ({descreverRelativo(janela.terminaEm, agora)}) — 7 dias após o último contato ({CANAL[janela.canal].label}
              {janela.touchLabel === '' ? '' : ` ${janela.touchLabel}`}). Uma venda até lá credita comissão.
            </>
          ) : (
            <>
              Janela de comissão vencida em <strong className="tabular-nums">{formatDateTime(janela.terminaEm)}</strong>: uma venda agora entra como venda normal da empresa, sem comissão.
            </>
          )}
        </p>
      ) : null}
    </Panel>
  );
}
